import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

export function notify(text, type = "success") {
  return Swal.fire({
            position: 'center',
            heightAuto: false,
            icon: type,
            text: text,
            showConfirmButton: true,
            confirmButtonText: 'OK',
            confirmButtonColor: '#187CC6'
          });
}

export function downloadFile(file) {
  const fileName =
    file.name && file.name.split('/').length && file.name.split('/').slice(-1)[0].split('.').length ?
      file.name.split('/').slice(-1)[0].split('.')[0] :
      'file';
  const href = URL.createObjectURL(file.url);
  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', `${fileName}.${file.url.type === 'application/x-zip-compressed' ? 'zip' : 'pdf'}`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
}

export function slugify(string) {
  return string
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/gi, '')
    .replace(/[^A-Z0-9]/gi, '-')
    .replace(/[^A-Z0-9]+$/gi, '')
    .replace(/^[^A-Z0-9]+/gi, '')
    .toLowerCase();
}